import Button from '@atlaskit/button/default/button';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { useIntl } from 'react-intl';

import messages from './messages';

type Props = {
	sending: boolean;
	rateLimited: boolean;
	error: 'failed' | 'rateLimited' | null;
	onClose: () => void;
	onConfirm: () => void;
};

export const CreditConfirmationModal = ({
	sending,
	rateLimited,
	error,
	onClose,
	onConfirm,
}: Props) => {
	const { formatMessage } = useIntl();
	return (
		<Modal
			width="small"
			onClose={() => {
				if (!sending) onClose();
			}}
		>
			<ModalHeader hasCloseButton>
				<ModalTitle>{formatMessage(messages.request)}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<Stack space="space.150">
					<Text>{formatMessage(messages.confirmation)}</Text>
					{error && (
						<Box role="alert">
							<Text>{formatMessage(messages[error])}</Text>
						</Box>
					)}
				</Stack>
			</ModalBody>
			<ModalFooter>
				<Button isDisabled={sending} onClick={onClose}>
					{formatMessage(messages.cancel)}
				</Button>
				<Button
					appearance="primary"
					isLoading={sending}
					isDisabled={sending || rateLimited}
					onClick={onConfirm}
				>
					{formatMessage(messages.request)}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
